import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,{attrs:{"app":"","dense":"","type":"error","dismissible":""},model:{value:(_vm.alert_logout),callback:function ($$v) {_vm.alert_logout=$$v},expression:"alert_logout"}},[_c(VRow,{staticClass:"px-1",attrs:{"align":"center","justify":"space-between"}},[_c('span',[_vm._v("\n      Sua sessão será expírada em "+_vm._s(_vm.alert_time)+" minutos. Refaça o login.\n    ")]),_c(VBtn,{staticClass:"black--text",attrs:{"small":"","color":"white"},on:{"click":_vm.goToLogin}},[_vm._v("Relogar")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }